module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"fail-password-confirm":"Password and confirmation aren\u0027t equal...","nevermind":"Nevermind","password-recover":"Recover your password","reinit":"Recover"},"fr_FR":{"fail-password-confirm":"Le mot de passe et sa confirmation sont différents...","nevermind":"Abandonner","password-recover":"Réinitialiser votre mot de passe","reinit":"Réinitialiser"}}')
  delete Component.options._Ctor
}
